import { Chip, Prompt } from './types';

export const prompts: Prompt[] = [
  {
    header: 'Midterm Elections 2026',
    displayText: 'How can I help Flip the House?',
  },
  {
    header: 'In the news',
    displayText: 'Can Trump cancel the midterms?',
  },
  {
    header: 'Make a change',
    displayText: 'How do we get rid of the Electoral College?',
  },
];

// Keeping this as a placeholder until we add most searched section back
export const chips: Chip[] = [];
